import styled from "styled-components";

const AppWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-top: ${props => props.theme.header.height};
  font-family: "Gotham A", Arial, sans-serif;
  background-color: ${props => props.theme.mainBackground};
`;

const ContentWrapper = styled.div`
  display: flex;
`;

export { AppWrapper, ContentWrapper };



// WEBPACK FOOTER //
// ./src/common/styled/app.js